// resolve-auth-device-endpoint.ts
//
// Endpoint của Edge Function `auth-device` — BFF proxy Google Device Flow
// (plan 260701-1941): CLI không còn ôm client secret, mọi call OAuth đi qua đây.
//
// Resolve 3 tầng như get-pack (dừng ở giá trị đầu tiên có):
//   (a) env AVATAR_AUTH_ENDPOINT
//   (b) <workspace>/.claude/settings.json env.AVATAR_AUTH_ENDPOINT (switch dev/prod)
//   (c) DEFAULT prod
//
// SECURITY: refresh_token/device_code gửi tới endpoint này — gate HTTPS +
// host whitelist áp lên giá trị CUỐI, chặn env/settings injection trỏ host lạ
// harvest credentials (mirror gate của getPackEndpoint).
import { readWorkspaceSettingsEnvOverride } from "./read-workspace-settings-env-override.js";
import { assertAllowedEndpointHost } from "./validate-endpoint-host-allowlist.js";

const DEFAULT_AUTH_DEVICE_ENDPOINT =
  "https://qpdbkewtpkkbcrptnlos.supabase.co/functions/v1/auth-device";

// Cùng project Supabase với get-pack (confirmed: cả hai Edge Function deploy
// chung 1 Supabase project — không phải copy-paste artifact). Exact host cho
// Supabase (chặn subdomain lạ *.supabase.co), suffix cho domain NAL sở hữu.
const ALLOWED_AUTH_DEVICE_HOSTS = {
  exactHosts: ["qpdbkewtpkkbcrptnlos.supabase.co"],
  suffixHosts: [".nal.vn", ".nal-software.com"],
};

export function resolveAuthDeviceEndpoint(): string {
  const endpoint =
    process.env.AVATAR_AUTH_ENDPOINT ??
    readWorkspaceSettingsEnvOverride("AVATAR_AUTH_ENDPOINT") ??
    DEFAULT_AUTH_DEVICE_ENDPOINT;

  let parsed: URL;
  try {
    parsed = new URL(endpoint);
  } catch {
    throw new Error(`AVATAR_AUTH_ENDPOINT không phải URL hợp lệ: ${endpoint}`);
  }
  if (parsed.protocol !== "https:") {
    throw new Error(
      `AVATAR_AUTH_ENDPOINT phải dùng HTTPS (nhận: ${parsed.protocol}). ` +
        `Từ chối gửi credentials qua kết nối không mã hóa.`,
    );
  }
  assertAllowedEndpointHost(
    parsed.hostname,
    ALLOWED_AUTH_DEVICE_HOSTS,
    (message) => new Error(`AVATAR_AUTH_ENDPOINT ${message}`),
  );
  return endpoint;
}
